import type { DataTableColumn } from "@design";
import { useTranslation } from "react-i18next";
import type { FeedbackResponse } from "@/api";
import { Text } from "@/components/Text";
import { formatDate } from "@/i18n/format";
import { CategoryBadge, StatusBadge, submitterOf } from "./FeedbackBadges";

export function useFeedbackColumns(): DataTableColumn<FeedbackResponse>[] {
  const { t } = useTranslation("adminFeedback");
  return [
    { key: "type", header: t("columns.type"), render: (item) => <CategoryBadge category={item.category} /> },
    {
      key: "title",
      header: t("columns.title"),
      mobile: "primary",
      render: (item) => (
        <Text as="span" variant="body-sm" className="line-clamp-2">
          {item.title}
        </Text>
      ),
    },
    {
      key: "submittedBy",
      header: t("columns.submittedBy"),
      render: (item) => (
        <Text as="span" variant="body-sm" tone="secondary" className="truncate">
          {submitterOf(item) ?? t("unknownUser")}
        </Text>
      ),
    },
    { key: "status", header: t("columns.status"), render: (item) => <StatusBadge status={item.status} /> },
    {
      key: "date",
      header: t("columns.date"),
      render: (item) => (
        <Text as="span" variant="body-sm" tone="secondary">
          {formatDate(item.createdAt)}
        </Text>
      ),
    },
  ];
}
